const namespace = 'components/snackbar';

export const SNACKBAR_SHOW = `${namespace}/SNACKBAR_SHOW`;

export const showSnackbar = (payload) => ({
  type: SNACKBAR_SHOW,
  payload,
});
